import fbg from '../../../assets/footet-bg.svg';

const DesktopFooter = ({ content, activeTab, handleIconClick, language }) => {
    return (
        <div
            className="w-full hidden md:flex items-center bg-cover bg-center min-w-[1172px] px-[200px] py-[33px] relative"
            style={{ backgroundImage: `url(${fbg})`, minHeight: '368px' }}
        >
            <div className="space-y-4 z-10">
                <p className="text-[42px] font-extrabold text-[#3032D4]">
                    {language === 'fa' ? 'ارتباط با ما' : 'Contact Us'}
                </p>

                {content.call?.phoneNumbers?.length > 0 && (
                    <button
                        onClick={() => handleIconClick('call')}
                        className={`flex items-center justify-center gap-2 text-[24px] px-2 rounded-xl font-bold transition-all w-[220px] h-[60px] ${activeTab === 'call'
                            ? 'bg-[#F7BD5F] text-[#204286] shadow-md'
                            : 'bg-white/80 text-[#204286]'
                            }`}
                    >
                        <img src='/call.svg' alt="" className='w-8' />
                        {language === 'fa' ? 'خطوط ارتباطی' : 'Contact'}
                    </button>
                )}

                {content.office?.addresses?.length > 0 && (
                    <button
                        onClick={() => handleIconClick('office')}
                       className={`flex items-center justify-center gap-2 text-[24px] px-2 rounded-xl font-bold transition-all w-[220px] h-[60px] ${activeTab === 'office'
                            ? 'bg-[#F7BD5F] text-[#204286] shadow-md'
                            : 'bg-white/80 text-[#204286]'
                            }`}
                    >
                        <img src='/office.svg' alt="" className='w-8' />
                        {language === 'fa' ? 'دفاتر شرکت' : 'Offices'}
                    </button>
                )}

                {content.social?.items?.length > 0 && (
                    <button
                        onClick={() => handleIconClick('social')}
                        className={`flex items-center justify-center gap-2 text-[24px] px-2 rounded-xl font-bold transition-all w-[220px] h-[60px] ${activeTab === 'social'
                            ? 'bg-[#F7BD5F] text-[#204286] shadow-md'
                            : 'bg-white/80 text-[#204286]'
                            }`}
                    >
                        <img src='/social.svg' alt="" className='w-8' />
                        {language === 'fa' ? 'فضای مجازی' : 'Social'}
                    </button>
                )}
            </div>

            {/* İçerik Alanı */}
            <div className="relative mr-[99px] flex-1">

                {/* Call içeriği */}
                {activeTab === 'call' && content.call?.phoneNumbers?.length > 0 && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-0 space-y-3 z-20">
                        {content.call.phoneNumbers.map((phone, idx) => (
                            <p key={idx} className="phone-number text-[#204286] text-2xl font-extrabold" dir="ltr">
                                {phone}
                            </p>
                        ))}
                        {content.call.international && (
                            <div>
                                <p className="text-[#3032D4] text-2xl font-extrabold">
                                    {content.call.international.label}
                                </p>
                                <p className="phone-number text-[#204286] text-2xl font-extrabold" dir="ltr">
                                    {content.call.international.number}
                                </p>
                            </div>
                        )}
                    </div>
                )}

                {/* Office içeriği */}
                {activeTab === 'office' && content.office?.addresses?.length > 0 && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-0 space-y-3 max-w-[450px] z-20">
                        {content.office.addresses.map((item, idx) => (
                            <div key={idx}>
                                {/* Uluslararası ofis başlığı */}
                                {item.isInternational && (
                                    <p className="text-[#3032D4] text-lg font-extrabold mb-1">
                                        {item.address}
                                    </p>
                                )}
                                {/* Normal adresler - link varsa tıklanabilir */}
                                {!item.isInternational && (
                                    item.url ? (
                                        <a
                                            href={item.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="block text-lg font-extrabold leading-relaxed text-[#204286] hover:opacity-80 transition-opacity"
                                        >
                                            {item.address}
                                        </a>
                                    ) : (
                                        <p className="text-lg font-extrabold leading-relaxed text-[#204286]">
                                            {item.address}
                                        </p>
                                    )
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Social içeriği */}
                {activeTab === 'social' && content.social?.items?.length > 0 && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-0 space-y-4 z-20">
                        {content.social.items.map((item, idx) => (
                            <a
                                key={idx}
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
                            >
                                <img src={item.icon} alt="" className="w-8 h-8" />
                                <p className="text-[#204286] text-lg font-extrabold">
                                    {item.title}
                                </p>
                            </a>
                        ))}
                    </div>
                )}

                {/* Boş durum mesajları */}
                {activeTab === 'call' && content.call?.phoneNumbers?.length === 0 && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-0 z-20">
                        <p className="text-[#204286] text-2xl font-extrabold">
                            {language === 'fa' ? 'اطلاعاتی موجود نیست' : 'No data available'}
                        </p>
                    </div>
                )}
                {activeTab === 'office' && content.office?.addresses?.length === 0 && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-0 z-20">
                        <p className="text-[#204286] text-2xl font-extrabold">
                            {language === 'fa' ? 'اطلاعاتی موجود نیست' : 'No data available'}
                        </p>
                    </div>
                )}
                {activeTab === 'social' && content.social?.items?.length === 0 && (
                    <div className="absolute top-1/2 -translate-y-1/2 right-0 z-20">
                        <p className="text-[#204286] text-2xl font-extrabold">
                            {language === 'fa' ? 'اطلاعاتی موجود نیست' : 'No data available'}
                        </p>
                    </div>
                )}
            </div>

            {/* Mask images */}
            {activeTab === 'call' && (
                <img src="/mask-phone.svg" className="absolute top-0 left-0 z-0" alt="" />
            )}
            {activeTab === 'office' && (
                <img src="/building.png" className="absolute bottom-0 left-20 z-0 w-[350px] h-[360px]" alt="" />
            )}
            {activeTab === 'social' && (
                <img src="/mask-web.svg" className="absolute top-0 left-0 z-0" alt="" />
            )}
        </div>
    );
};

export default DesktopFooter;